<template>
    <div>
        <div class="w-100 bg-tealgray200 tealgray600 mb-5 fw-400"><h2 class="py-5 fw-400 text-center"> PROJECT CODE
            LIST </h2></div>

        <b-container>
            <b-tabs v-if="projects_periods.length" id="project-code-list-tab" v-model="selected_period"
                    content-class="py-3">
                <div v-if="is_admin === 4"
                     style="margin-top: -54px;"
                     class="text-right"
                >

                    <b-button
                        size="sm"
                        variant="outline-primary"
                        :disabled="downloading_statistics === true"
                        @click="downloadStatistics(projects_periods[selected_period])"
                    >
                        <span v-if="downloading_statistics !== true">
                            PERIOD 산업 통계 다운로드 <fa icon="file-excel" class="ml-1"/>
                        </span>
                        <span v-else>
                            <b-spinner small></b-spinner> 파일을 준비하는 중... (최대 1분이 소요됩니다)
                        </span>
                    </b-button>
                </div>
                <b-card no-body bg-variant="white"
                        :style="{marginTop: is_admin === 4 ? '28px' : '0px'}"
                >
                    <div class="p-3">
                        <b-form id="project-search-form"
                                autocomplete="new-password"
                                @submit.stop.prevent="searchData"
                                @reset="resetForm"
                        >
                            <div class="d-flex justify-content-between align-items-end">
                                <b-form-group
                                    id="fieldset-input-project_code"
                                    :label="$t('프로젝트 코드 검색')"
                                    label-for="ais-input-project_code"
                                    class="mb-0 w-100 mr-3"
                                >
                                    <b-form-input id="ais-input-project_code"
                                                  v-model="searchFormValue.project_code"
                                                  :disabled="listLoading"
                                                  trim
                                    />
                                </b-form-group>

                                <div>
                                    <b-button
                                        variant="primary"
                                        :disabled="listLoading"
                                        form="project-search-form"
                                        type="submit"
                                    >
                                        {{ $t('검색하기') }}
                                    </b-button>
                                </div>
                            </div>
                        </b-form>
                    </div>
                </b-card>

                <b-tab v-for="(period, period_idx) in projects_periods"
                       :key="period"
                       :title="period"
                       :active="period_idx === selected_period"
                >


                    <b-table id="project-table" :fields="project_code_fields" :items="searchResults"
                             class="sep-table"
                             hover
                             responsive
                             show-empty
                             :busy="listLoading"
                    >
                        <template #empty>
                            <PageEmptyComponent
                                :text="$t('조회된 프로젝트가 없습니다.')"
                                :loading="listLoading"
                                :loadingText="$t('프로젝트를 조회중입니다.')"
                            />
                        </template>
                        <template #thead-top>
                            <b-tr role="row" class="tealgray600">
                                <b-th rowspan="2" scope="col" class="align-middle">
                                    프로젝트 코드
                                </b-th>
                                <b-th rowspan="2" scope="col" class="align-middle">
                                    마감
                                </b-th>
                                <b-th rowspan="2" scope="col" class="align-middle">
                                    Total
                                </b-th>
                                <b-th colspan="8" scope="col" class="align-middle text-center bg-light">상태</b-th>
                                <b-th colspan="2" scope="col" class="align-middle text-center">타입</b-th>
                                <b-th rowspan="2" scope="col" class="align-middle text-center">관리</b-th>
                                <template v-if="is_admin >= 3">
                                    <b-th rowspan="2" scope="col" class="align-middle text-center"
                                          style="max-width: 250px; min-width: 150px;"
                                    >
                                        관리자 메모
                                    </b-th>
                                </template>
                            </b-tr>
                            <b-tr role="row" class="tealgray600">
                                <b-th role="columnheader" scope="col" aria-colindex="4" class="bg-light text-center"
                                      style="top: 36px !important;">
                                    <div class="f-85">에코바디스</div>
                                </b-th>
                                <b-th role="columnheader" scope="col" aria-colindex="4" class="bg-light text-center"
                                      style="top: 36px !important;">
                                    <div class="f-85">미신청</div>
                                </b-th>
                                <b-th role="columnheader" scope="col" aria-colindex="5" class="bg-light text-center"
                                      style="top: 36px !important;">
                                    <div class="f-85">신청됨</div>
                                </b-th>
                                <b-th role="columnheader" scope="col" aria-colindex="6" class="bg-light text-center"
                                      style="top: 36px !important;">
                                    <div class="f-85">답변중</div>
                                </b-th>
                                <b-th role="columnheader" scope="col" aria-colindex="7" class="bg-light text-center"
                                      style="top: 36px !important;">
                                    <div class="f-85">보완중</div>
                                </b-th>
                                <b-th role="columnheader" scope="col" aria-colindex="8" class="bg-light text-center"
                                      style="top: 36px !important;">
                                    <div class="f-85">평가중</div>
                                </b-th>
                                <b-th role="columnheader" scope="col" aria-colindex="9" class="bg-light text-center"
                                      style="top: 36px !important;">
                                    <div class="f-85">완료</div>
                                </b-th>
                                <b-th role="columnheader" scope="col" aria-colindex="10" class="bg-light text-center"
                                      style="top: 36px !important;">
                                    <div class="f-85">취소</div>
                                </b-th>
                                <b-th role="columnheader" scope="col" aria-colindex="11" class="text-center"
                                      style="top: 36px !important;">
                                    <div class="f-85">일반</div>
                                </b-th>
                                <b-th role="columnheader" scope="col" aria-colindex="12" class="text-center"
                                      style="top: 36px !important;">
                                    <div class="f-85">심화</div>
                                </b-th>
                            </b-tr>
                        </template>


                        <template #cell(project_code)="data">
                            <div class="f-90 pb-2 fw-600 f-100">{{ data.value }}</div>
                            {{ data.item.client }}
                            <div class="f-80 pt-1 gray-500 fw-300">{{ data.item.manager }}</div>
                        </template>

                        <template #cell(target_end_date)="data">
                                            <span :class="getUrgentColor(getLeftDays(data.value))">
                                                {{ getLeftDays(data.value) }}
                                            </span>
                            <template v-if="getLeftDays(data.value) !== 'open'">
                                <span class="f-90 fw-300">일 남음</span>
                            </template>
                            <div class="f-90 fw-300">~ {{
                                    !data.value ? '' : formatDate(data.value, 'YYYY-MM-DD')
                                }}
                            </div>
                        </template>

                        <template #cell(미신청)="data">
                            {{ data.value ? data.value : ' - ' }}
                        </template>

                        <template #cell(신청됨)="data">
                            {{ data.value ? data.value : ' - ' }}
                        </template>

                        <template #cell(답변중)="data">
                            {{ data.value ? data.value : ' - ' }}
                        </template>

                        <template #cell(보완중)="data">
                            {{ data.value ? data.value : ' - ' }}
                        </template>

                        <template #cell(평가중)="data">
                            {{ data.value ? data.value : ' - ' }}
                        </template>

                        <template #cell(완료)="data">
                            {{ data.value ? data.value : ' - ' }}
                        </template>

                        <template #cell(취소)="data">
                            {{ data.value ? data.value : ' - ' }}
                        </template>

                        <template #cell(managing)="data">
                            <b-button-group vertical style="min-width: 85px;">
                                <b-button variant="dark-border" size="sm"
                                          @click="enterProjectCode('ProjectProgress', data.item)"
                                >
                                    진행현황
                                </b-button>
                                <b-button variant="dark-border" size="sm"
                                          @click="enterProjectCode('Answers', data.item)"
                                >
                                    기업별 답변
                                </b-button>
                                <b-button variant="dark-border" size="sm"
                                          @click="enterProjectCode('CampaignReport', data.item)"
                                >
                                    평가결과
                                </b-button>
                                <b-button v-if="is_admin === 4"
                                          variant="dark-border"
                                          size="sm"
                                          @click="enterProjectCode('ReportBulkRun', data.item)"
                                >
                                    보고서 일괄생성
                                </b-button>
                            </b-button-group>
                        </template>

                        <template #cell(memo)="data">
                            <div style="max-width: 250px; min-width: 150px;">
                                <div v-if="!is_editing_memo[data.index]" class="f-90" v-html="data.value"></div>
                                <b-form-textarea v-else v-model="data.item.memo" class="f-90"
                                                 :disabled="data.item.is_completed"></b-form-textarea>
                                <template v-if="is_admin === 4">
                                    <b-button :variant="!is_editing_memo[data.index] ? 'dark-border' : ''"
                                              size="sm"
                                              class="float-right mt-1"
                                              :class="!is_editing_memo[data.index] ? 'py-0 px-1' : ''"
                                              :disabled="data.item.is_completed"
                                              @click="toggleEditor(data.index)"
                                    >
                                        <template v-if="!is_editing_memo[data.index]">
                                            <fa icon="pen"></fa>
                                        </template>
                                        <template v-else>취소</template>
                                    </b-button>
                                    <b-button v-if="is_editing_memo[data.index]"
                                              variant="blue"
                                              size="sm"
                                              class="float-right mr-1 mt-1"
                                              @click="handleSaveProjectMemo(data.item, data.index)">
                                        :disabled="data.item.is_completed"
                                        저장
                                    </b-button>
                                </template>
                            </div>

                        </template>
                    </b-table>
                    <div class="d-flex justify-content-end align-items-center mt-3">
                        <b-pagination
                            ref="pagination"
                            v-model="pagination.currentPage"
                            aria-controls="project-table"
                            :total-rows="pagination.totalRows"
                            :per-page="pagination.perPage"
                            first-number
                            last-number
                            :disabled="listLoading"
                            align="right"
                            @change="(page)=>changeQuery({page})"
                        ></b-pagination>
                        <b-form-select
                            v-model="pagination.perPage"
                            class="ml-3 mb-3"
                            style="width: 100px"
                            size="sm"
                            :disabled="listLoading"
                            @change="(pageSize)=>changeQuery({pageSize})"
                        >
                            <b-form-select-option v-for="data in perPageOptions"
                                                  :key="`${data.text}-${data.value}`"
                                                  :value="data.value">{{ data.text }}
                            </b-form-select-option>
                        </b-form-select>
                    </div>
                </b-tab>
            </b-tabs>
        </b-container>
        <hr class="border-0 py-5">
    </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import downloadFile from '@shared_mixins/downloadFile';
import {getDefaultPagination, getPerPageOptions} from '@shared/utils/common';
import axios from '@core/utils/api/_axios';
import PageEmptyComponent from '@shared/components/admin/components/common/PageEmptyComponent.vue';

const projects_periods = ['2024_1H', '2025_1H', '2026_1H']
export default {
    name: 'ProjectCodeList',
    components: {PageEmptyComponent},
    mixins: [
        downloadFile
    ],
    props: {
        urlError: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            basic_status: ['에코바디스', '미신청', '신청됨', '답변중', '보완중', '평가중', '완료', '취소'],
            basic_types: ['일반', '심화'],
            is_editing_memo: [],
            downloading_statistics: false,

            listLoading: false,
            projects_periods: projects_periods,
            selected_period: projects_periods.length - 1,

            searchResults: null,
            searchFormValue: {
                project_code: '',
                period: null,
            },
            pagination: getDefaultPagination(1, 20),
            perPageOptions: getPerPageOptions(),
        };
    },
    computed: {
        ...mapState(['user_id', 'is_admin']),
        ...mapState('project_code', ['project_codes', 'is_project_codes_loaded', 'project_companies']),
        project_code_fields() {
            const _common_project_code_table_field = [
                {
                    key: 'project_code',
                    label: '프로젝트 코드',
                    thClass: 'd-none'
                },
                {
                    key: 'target_end_date',
                    label: '마감',
                    thClass: 'd-none'
                },
                {
                    key: 'num_of_companies',
                    label: 'Total',
                    thClass: 'd-none',
                    tdClass: 'text-center'
                },
                {
                    key: '에코바디스',
                    thClass: 'd-none',
                    tdClass: 'text-center'
                },
                {
                    key: '미신청',
                    thClass: 'd-none',
                    tdClass: 'text-center'
                },
                {
                    key: '신청됨',
                    thClass: 'd-none',
                    tdClass: 'text-center'
                },
                {
                    key: '답변중',
                    thClass: 'd-none',
                    tdClass: 'text-center'
                },
                {
                    key: '보완중',
                    thClass: 'd-none',
                    tdClass: 'text-center'
                },
                {
                    key: '평가중',
                    thClass: 'd-none',
                    tdClass: 'text-center'
                },
                {
                    key: '완료',
                    thClass: 'd-none',
                    tdClass: 'text-center'
                },
                {
                    key: '취소',
                    thClass: 'd-none',
                    tdClass: 'text-center'
                },
                {
                    key: '일반',
                    tdClass: 'bg-linen100',
                    thClass: 'd-none text-center'
                },
                {
                    key: '심화',
                    tdClass: 'bg-linen100',
                    thClass: 'd-none text-center'
                },
                {
                    key: 'managing',
                    label: '관리',
                    thClass: 'd-none'
                }
            ];

            if (this.is_admin >= 3) {
                _common_project_code_table_field.push({
                    key: 'memo',
                    thClass: 'd-none',
                    thStyle: 'max-width: 250px; min-width: 150px;',
                    label: '관리자 메모'
                });
            }

            return _common_project_code_table_field;
        },
    },
    watch: {
        '$route': {
            handler() {
                this.setSearchDataFormQuery();
                this.fetchData();
            }
        },
        selected_period(newVal) {
            if (newVal != null) {
                this.searchFormValue.period = this.projects_periods[newVal];
                this.changeQuery({});
            }
        },
    },
    async created() {
        this.perPageOptions.splice(-1, 1);

        if (this.$route.params?.urlError) {
            this.$showModal({
                type: 'alert',
                state: 'warning',
                title: this.$t('잘못된 접근'), // content는 기본값 사용, title만 변경
                message: this.$t('URL에 필요한 정보가 부족합니다. 개발팀에 문의해주세요.'),
            });
        }


    },
    async mounted() {
        try {
            this.set_admin_mode('project');
            this.setSearchDataFormQuery();
            if (Object.keys(this.$route.query).length > 0)
                await this.fetchData();
            else
                await this.changeQuery({});
            this.update_is_premium(true);
        } catch (error) {
            console.log(error);
        }
    },
    beforeDestroy() {
        this.update_custom_project_codes_list([]);
        this.update_is_project_codes_loaded(false);
    },
    methods: {
        ...mapMutations('project_code', ['update_is_project_codes_loaded', 'update_custom_project_codes_list', 'update_now_project']),
        ...mapMutations('score', ['add_all_temp_target_companies']),
        ...mapMutations(['set_admin_mode']),
        ...mapMutations('payment', ['update_is_premium']),
        ...mapActions('project_code', ['readProjectCodes', 'readProjectCompaniesCampaigns']),
        async searchData() {
            this.pagination.currentPage = 1;
            await this.changeQuery({});
        },
        setSearchDataFormQuery() {
            this.searchFormValue.project_code = this.$route.query.project_code || null;
            this.selected_period = this.projects_periods.indexOf(this.$route.query.period) === -1 ? this.projects_periods.length - 1 : this.projects_periods.indexOf(this.$route.query.period);
            
            this.searchFormValue.period = this.projects_periods[this.selected_period];
            this.pagination.currentPage = Number(this.$route.query.current_page) || 1;
            this.pagination.perPage = Number(this.$route.query.per_page) || 20;
        },
        async changeQuery({page, pageSize}) {
            const query = {};
            let checkSameQuery = true;
            const toQueryObj = {
                ...this.searchFormValue,
                current_page: page ?? this.pagination.currentPage,
                per_page: pageSize ?? this.pagination.perPage
            };

            Object.entries(toQueryObj).forEach(([key, item]) => {
                if (item != null && item !== '') {
                    if (query[key] !== toQueryObj[key]) {
                        checkSameQuery = false;
                        query[key] = toQueryObj[key];
                    }
                }
            });

            if (!checkSameQuery) {
                await this.$router.push({query}).catch(e => {
                });
            }
        },
        resetForm() {
            this.searchFormValue = {
                project_code: null,
            };
        },
        async fetchData() {
            try {
                this.listLoading = true;

                this.searchResults = null;

                const res = await axios.get('/projects', {
                    params: {
                        user_id: this.user_id,
                        period: this.searchFormValue.period,
                        project_code: this.searchFormValue.project_code,
                        page: this.pagination.currentPage,
                        per_page: this.pagination.perPage,
                    }
                });

                const {items, total, page} = res.data;

                this.searchResults = items.map((item, index) => {
                    const data = {
                        ...item,
                        index: total - (this.pagination.perPage * (this.pagination.currentPage - 1) + index),
                    };
                    return data;
                });

                
                
                this.pagination.totalRows = Number(total);
                this.pagination.currentPage = null;
                setTimeout(()=>{
                    this.pagination.currentPage = Number(page);   
                });
            } catch (e) {
                console.dir(e);
                this.$EventBus.$emit('toast-failure', this.$t('검색 오류'), '프로젝트 검색 도중 오류가 발생했습니다. 잠시후 재시도 해주세요.');
            } finally {
                this.listLoading = false;

            }

        },
        getLeftDays(target_end_date) {
            // if(target_end_date!='NaT'){
            //     if (this.isIE === true) {
            //         // let txt_date = target_end_date.replace("-", "/")
            //         let gap = new Date(target_end_date).getTime() - new Date().getTime()
            //         return Math.floor(gap / (1000 * 60 * 60 * 24)); // 남은 일수
            //     }
            //     else {
            //         let gap = new Date(target_end_date).getTime() - new Date().getTime()
            //         return Math.floor(gap / (1000 * 60 * 60 * 24)); // 남은 일수 
            //     }
            // }
            if (!target_end_date) {
                return 'open';
            } else {
                let gap = new Date(target_end_date).getTime() - new Date().getTime();
                return Math.floor(gap / (1000 * 60 * 60 * 24)); // 남은 일수 
            }
        },
        async enterProjectCode(mode, project) {
            this.$router.push({
                name: mode,
                query: {client: project.client, pc: project.project_code, cmp: project.campaign, admin_mode: 'project'}
            });
        },
        toggleEditor(idx) {
            console.log('toggleEditor ~ ');
            console.log(' ~ this.is_editing_memo[idx] => ', this.is_editing_memo[idx]);

            // this.is_editing_memo[idx] = !this.is_editing_memo[idx]
            console.log(' ~ this.is_editing_memo[idx] => ', this.is_editing_memo[idx]);

            this.$set(this.is_editing_memo, idx, !this.is_editing_memo[idx]);
        },
        async handleSaveProjectMemo(item, idx) {
            if (item.memo && item.memo) {
                await this.saveProjectMemo(item);
                this.is_editing_memo.splice(idx, 1, false);
            } else {
                alert('내용을 입력해 주세요');
            }
        },
        async saveProjectMemo(item) {
            let formData = new FormData;
            formData.append('user_id', this.user_id);
            formData.append('project_code', item.project_code);
            formData.append('memo', item.memo);

            const response = await this.$axios.post('/save_project_memo', formData);
            this.$emit('toast-success', '저장완료', response.data.msg);
        },
        async downloadStatistics(period) {
            try {
                this.downloading_statistics = true;
                const response = await this.$axios.get(`/scores/excel/periods/${period}`, {
                    responseType: 'blob'
                });

                this.downloadFileFromResponse(response, `${period}_산업_통계_데이터`);
            } catch (error) {
                console.log(error);
            } finally {
                this.downloading_statistics = false;
            }
        },
        getUrgentColor(left_days) {
            if (left_days < 0) {
                return 'gray-500';
            } else if (left_days >= 0 && left_days <= 20) {
                return 'red fw-600';
            } else if (left_days === 'open') {
                return 'blue';
            } else {
                return 'fw-600';
            }
        },
    }
};
</script>

<style>
#project-code-list-tab__BV_tab_controls_ > li > .nav-link {
    color: var(--gray-600);
}

#project-code-list-tab__BV_tab_controls_ > li > .nav-link.active {
    background-color: var(--tealgray400);
    color: white;
    font-weight: 600;
    border-color: var(--tealgray400) var(--tealgray400) var(--tealgray400);

}

#project-code-list-tab__BV_tab_controls_ {
    border-bottom: 1px solid var(--tealgray400);
}

</style>
